import React from 'react';
import './service.css';
import TaxServices from './TaxServices';
import Footer from '../Common/Footer';
import Navbar from '../Common/Navbar';
// import TaxServices from './TaxServices';

const Services = () => {

    return (
        <>
            <div className="service_container">
                <div className="service_bg">
                    <Navbar />
                    <div className="service_head_container">
                        <h1>Our Services</h1>
                        <p className="service_head_subtitle">
                            Professional, comprehensive, and tailored solutions for all your personal and corporate tax and financial needs.
                        </p>
                    </div>
                </div>
            </div>
            {/* OUR TAX SERVICES START*/}
            <TaxServices />
            {/* OUR TAX SERVICES END */}

            <Footer />

        </>
    )
}

export default Services;